(() => {
  // ponytail: this controls visibility only; use server-side IP checks if membership content needs access protection.
  function applyRegion() {
    let region = '';
    try {
      region = window.Shopify?.customerPrivacy?.getRegion() || '';
    } catch {
      // Keep the Vietnam-only content hidden when detection fails.
    }
    document.documentElement.dataset.membershipRegion = region.slice(0, 2).toUpperCase() === 'VN' ? 'VN' : 'other';
  }

  if (window.Shopify?.customerPrivacy?.getRegion) {
    applyRegion();
  } else {
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], applyRegion);
  }
})();
